module.exports = __webpack_public_path__ + "static/media/skull.b8c32789.svg";